import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import { TextWrap as Text, View, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets

export default function Subscription({ navigation }: RootStackScreenProps<'Subscription'>) {
  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View style={{ justifyContent: 'center' }}>
        <Text style={[sc.h2, { textAlign: 'left', marginTop: 40 }]}>Manage Subscription</Text>
        <Text style={[sc.blockParagraph, { marginTop: 40 }]}>
          To modify or cancel your current subscription please email{' '}
          <a href="mailto:help@snapcalorie.com" target="_new">
            help@snapcalorie.com
          </a>{' '}
          and we will assist with your request.
        </Text>
      </View>
    </SnapCalorieSitePage>
  );
}
